import {
  DistanceFilterDropdown,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceFilters/DistanceFilterDropdown'

export function DistanceToCenterFilter() {
  return (
    <DistanceFilterDropdown
      filterType="MetersToCenter"
      labelId="distance_to_center_label"
      analyticsType="distance from city center"
      dataQa="distance-to-center-filter"
    />
  )
}
